import { render, staticRenderFns } from "./AverageBookingPriceTile.vue?vue&type=template&id=2f418c44"
import script from "./AverageBookingPriceTile.vue?vue&type=script&lang=js"
export * from "./AverageBookingPriceTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports